export const languageElements = {
  items: {
    "greeting-header": {
      hu: "Üdvözöljük!",
      de: "Herzlich wilkommen!",
      en: "Welcome!",
    },

    "greeting-p-01": {
      hu: "Ezen az oldalon információkat kaphat számláiról, raktári készleteiről és fuvarmegbízásai állapotáról.",
      de: "Auf dieser Website erhalten Sie Informationen zu Ihren Rechnungen, Lagerbeständen und dem Status Ihrer Frachtaufträge.",
      en: "On this website you can get information about your invoices, stock levels and the status of your freight orders.",
    },

    "btn-login": {
      hu: "Belépés",
      de: "Login",
      en: "Login",
    },
  },
};
